// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.2_webpack@5.91.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.project-name-change-warning {
  transition: opacity 0.5s ease-in-out, max-height 0.5s ease-in-out;
}
.project-name-change-warning__animation-enter {
  max-height: 0;
  opacity: 0;
}
.project-name-change-warning__animation-enter-active {
  max-height: 999px;
  opacity: 1;
}
.project-name-change-warning__animation-exit {
  max-height: 999px;
  opacity: 1;
}
.project-name-change-warning__animation-exit-active {
  max-height: 0;
  opacity: 0;
}
`, "",{"version":3,"sources":["webpack://./src/neptune-app/components/projects/project-form/ProjectNameChangeWarning.less"],"names":[],"mappings":"AACA;EAII,iEAAA;AAHJ;AAMQ;EACE,aAAA;EACA,UAAA;AAJV;AAMU;EACE,iBAAA;EACA,UAAA;AAJZ;AAQQ;EACE,iBAAA;EACA,UAAA;AANV;AAOU;EACE,aAAA;EACA,UAAA;AALZ","sourcesContent":["\n.project-name-change-warning {\n    // content shouldn't take more height than this max-height. \n    @safeMaxHeightValue: 999px;\n    \n    transition: opacity 0.5s ease-in-out, max-height 0.5s ease-in-out;\n    \n    &__animation {\n        &-enter {\n          max-height: 0;\n          opacity: 0;\n    \n          &-active {\n            max-height: @safeMaxHeightValue;\n            opacity: 1;\n          }\n        }\n    \n        &-exit {\n          max-height: @safeMaxHeightValue;\n          opacity: 1;\n          &-active {\n            max-height: 0;\n            opacity: 0;\n          }\n        }\n      }\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
